module.exports = __webpack_public_path__ + "static/media/other_white_icon.a3f6fb81.svg";